var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGit = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 16,
  viewBox: "0 0 16 16",
  width: 16,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h16v16h-16z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.2173 7.33198-6.54907-6.548752c-.37709-.377251-.98875-.377251-1.36617 0l-1.3598 1.360122 1.72497 1.72498c.40092-.13549.86061-.04457 1.18007.27506.32143.32158.41154.78519.27262 1.18758l1.66278 1.66261c.4024-.13875.8663-.04897 1.1876.27278.4489.44891.4489 1.17631 0 1.62555-.4493.44908-1.1767.44908-1.6261 0-.3376-.33791-.42114-.83416-.2499-1.2501l-1.55079-1.55063v4.08052c.10937.0542.21271.1264.30379.2175.44892.4489.44892 1.1763 0 1.6257-.44891.4487-1.1768.4487-1.62539 0-.44891-.4496-.44891-1.177 0-1.6257.111-.1109.23947-.1948.3766-.2509v-4.11862c-.13713-.05615-.26527-.13924-.3766-.2509-.34003-.33987-.42182-.83906-.24747-1.25663l-1.70049-1.70081-4.490768 4.49028c-.377251.37757-.377251.98924 0 1.36649l6.549408 6.54889c.37709.3773.98859.3773 1.36616 0l6.51855-6.51853c.3773-.37725.3773-.98924 0-1.36649z",
  fill: "currentColor"
}))));
export default SvgGit;